import { Alert, Button, Card, Flex, Grid } from "@mantine/core"
import { FaApple, FaUbuntu, FaWindows } from "react-icons/fa";
import { download_links } from "../util";
import DownloadChecksum from "./downloadchecksum";
import { motion, Variants } from "framer-motion";


interface DownloadCardProps {
    disabled?: boolean,
    type: "windows" | "macintel" | "macsilicon" | "linux"
}

const DownloadCard = ({type, disabled}: DownloadCardProps) => {
    const prettyLabels = {
        windows: "Windows",
        macintel: "Mac OS (Intel)",
        macsilicon: "Mac OS (Apple Silicon)",
        linux: "Ubuntu (Debian)"
    }

    const icons = {
        windows: <FaWindows 
            size={100}
            color="white"
        />,
        macintel: <FaApple 
            size={100}
            color="white"
        />,
        macsilicon: <FaApple
            size={100}
            color="white"
         />,
        linux: <FaUbuntu 
            size={100}
            color="white"
        />
    }
    return (
        <Card
            mih="300px"
            withBorder
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
                gap: "50px"
            }}
        >
            <Grid
                w="100%"
            >
                <Grid.Col span={2} style={{display: "flex", justifyContent: "center"}}>
                    {icons[type]}
                </Grid.Col>
                <Grid.Col span={10} style={{display: "flex", justifyContent: "center" ,flexDirection: "column", gap: "20px"}}>
                    <DownloadChecksum os={type} algorithm="SHA-256" />
                    <Button
                        variant="outline"
                        pt={"2px"}
                        disabled={disabled}
                        onClick={() => {
                        window.open(download_links[type], "_blank")
                        }}
                    >
                        {disabled ? "Currently Unavailable" : "Download For " + prettyLabels[type]}
                    </Button>
                </Grid.Col>
            </Grid>
        </Card>
    )
}

export default DownloadCard;